module.exports = __webpack_public_path__ + "static/media/8770.4c2db771.png";